export default __webpack_public_path__ + "static/media/kenza.e6129e69.webp";